import { Modal } from './modal.js';
import axios from 'axios';
import hljs from 'highlight.js';

export const handleBlog = () => {
   const buttons = document.querySelectorAll('.js-asyncPostGet');
   if (!buttons) return false;
   const modal = new Modal({ mode: 'modal--full' });
   buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
         e.preventDefault();
         const id = btn.getAttribute('data-id');
         console.log(id);
         const data = new FormData();
         data.append('action', 'ajax_get_post');
         data.append('postID', id);
         btn.classList.add('btn--loading');
         axios.post(settings.ajaxurl, data).then((response) => {
            console.log(response);
            btn.classList.remove('btn--loading');
            modal.open();
            modal.loadContent(`
               <div class="container">
                  <div class="row">
                     <div class="col-xl-8 ms-auto me-auto pt-5 pb-5">
                        <div class="bg-fourth overflow-scroll">
                           <h2 class="h2">${response.data.title}</h2>
                           ${response.data.content}
                        </div>
                     </div>
                  </div>
               </div>
            `);
            hljs.highlightAll();
         });
      });
   });
};
